import app from 'locales/en/app.json';
import common from 'locales/en/common.json';
import validation from 'locales/en/validation.json';
import dashboard from 'locales/en/dashboard.json';
import tutorials from 'locales/en/tutorials.json';
import myGiftCards from 'locales/en/my-gift-cards.json';
import orderHistory from 'locales/en/order-history.json';
import users from 'locales/en/users.json';
import redemptions from 'locales/en/redemptions.json';
import auth from 'locales/en/auth.json';
import finance from 'locales/en/finance.json';
import getStarted from 'locales/en/get-started.json';
import termsAndConditions from 'locales/en/terms-and-conditions.json';
import privacyPolicy from 'locales/en/privacy-policy.json';
import subscription from 'locales/en/subscription.json';

export const en_namespaces = {
  app,
  common,
  validation,
  dashboard,
  tutorials,
  'my-gift-cards': myGiftCards,
  'order-history': orderHistory,
  users,
  redemptions,
  auth,
  finance,
  subscription,
  'get-started': getStarted,
  'terms-and-conditions': termsAndConditions,
  'privacy-policy': privacyPolicy,
};
